import { getCredentialsHeaders, urls } from "@selector/shared";

type FP = (id: number) => Promise<{ type: string | null; content: string | Blob | null; error?: string | null }>;

export const getFilePreview: FP = async (fileId) => {
  try {
    const response = await fetch(`${urls.api}/showFile/${fileId}`, {
      method: "GET",
      credentials: "include",
      headers: {
        ...getCredentialsHeaders(),
      },
    });

    if (response.status === 400) {
      const errorText = await response.text();
      return { type: null, content: null, error: errorText };
    }

    const responseType = response.headers.get("Content-Type");

    if (!responseType) {
      throw new Error("File type is unknown");
    }

    return {
      type: responseType,
      content: await (responseType.startsWith("text/plain") || responseType.startsWith("text/markdown")
        ? response.text()
        : response.blob()),
    };
  } catch (error) {
    // should never happen since everything is handled on the MT
    // i.e. the error will be shown directly in the dialog itself
    return { type: null, content: null, error: error as string };
  }
};
